import DataPointRefundSuccess from "../../../../components/units/DataPoint/RefundHistory/DataPointRefundSuccess";

export default function DataPointRefundHistoryPage() {
  return <DataPointRefundSuccess />;
}
